import React from "react";
import { Styles, View, ViewProps } from "@react-pdf/renderer";

export type CarPdfStyle = Styles[number];

export type CarPdfBoxProps = React.PropsWithChildren<ViewProps>;

export const CarPdfBox = ({ ...props }: CarPdfBoxProps) => <View {...props} />;
